export const SUCCESS_TOAST = "success";
export const ERROR_TOAST = "error";
